import {ChangeEvent} from 'react';

export const preventDefaultOnChange = (e: ChangeEvent<HTMLInputElement>) => {
  e.preventDefault();
};
